import localeEn from 'dayjs/locale/en';
import localeNb from 'dayjs/locale/nb';
import localeFr from 'dayjs/locale/fr';
import localeIt from 'dayjs/locale/it';
import localeDe from 'dayjs/locale/de';
import localeEs from 'dayjs/locale/es';
import localeSv from 'dayjs/locale/sv';

import { LOCALE_CODES } from './locales';

const dayJsLocalesDict = {
  [LOCALE_CODES.ENGLISH]: localeEn,
  [LOCALE_CODES.NORWEGIAN]: localeNb,
  [LOCALE_CODES.FRENCH]: localeFr,
  [LOCALE_CODES.ITALIAN]: localeIt,
  [LOCALE_CODES.GERMAN]: localeDe,
  [LOCALE_CODES.SPANISH]: localeEs,
  [LOCALE_CODES.SWEDISH]: localeSv,
};

export const getDayJsLocale = (localeCode: LOCALE_CODES) => dayJsLocalesDict[localeCode];
